import { render } from "./ProfileFormBasic.vue?vue&type=template&id=22aee3f0&scoped=true"
import script from "./ProfileFormBasic.vue?vue&type=script&lang=js"
export * from "./ProfileFormBasic.vue?vue&type=script&lang=js"

import "./ProfileFormBasic.vue?vue&type=style&index=0&id=22aee3f0&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22aee3f0"]])

export default __exports__